import { createSlice } from '@reduxjs/toolkit';

const eInvoiceSlice = createSlice({
  name: 'eInvoiceSlice',
  initialState: {
    isLoading: false,
    isViewLoading: false,
    isDownloadLoading: false,
    isCorrectLoading: false,
    isCreditLoading: false,
    isSpLoading: false,
    isSpDownloadLoading: false,
    eInvoiceListData: {
      list: [],
      total: 0,
      limit: 10,
    },
    spInvoiceListData: {
      list: [],
      total: 0,
      limit: 10,
    },
    viewEInvoiceDetails: null,
    isError: null,
  },
  reducers: {
    /////// E-Invoice list start //////
    requestEInvoiceList: (state) => {
      return {
        ...state,
        isLoading: true,
        eInvoiceListData: {
          list: [],
          total: 0,
          limit: 10,
        },
      };
    },
    responseEInvoiceList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        eInvoiceListData: action?.payload?.data,
      };
    },
    failureEInvoiceList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },

    ////////// E-Invoice View Details /////////
    requestEInvoiceView: (state) => {
      return { ...state, isViewLoading: true };
    },
    responseEInvoiceView: (state, action) => {
      return {
        ...state,
        isViewLoading: false,
        viewEInvoiceDetails: action.payload,
      };
    },
    failureEInvoiceView: (state, action) => {
      return { ...state, isViewLoading: false, isError: action?.payload };
    },

    ////////// E-Invoice Download PDF /////////
    requestEInvoiceDownload: (state) => {
      return { ...state, isDownloadLoading: true };
    },
    responseEInvoiceDownload: (state) => {
      return { ...state, isDownloadLoading: false };
    },
    failureEInvoiceDownload: (state, action) => {
      return { ...state, isDownloadLoading: false, isError: action?.payload };
    },

    ////////// Correct Recipients /////////
    requestCorrectRecipients: (state) => {
      return { ...state, isCorrectLoading: true };
    },
    responseCorrectRecipients: (state) => {
      return { ...state, isCorrectLoading: false };
    },
    failureCorrectRecipients: (state, action) => {
      return { ...state, isCorrectLoading: false, isError: action?.payload };
    },

    ////////// Credit Invoice /////////
    requestCreditInvoice: (state) => {
      return { ...state, isCreditLoading: true };
    },
    responseCreditInvoice: (state) => {
      return { ...state, isCreditLoading: false };
    },
    failureCreditInvoice: (state, action) => {
      return { ...state, isCreditLoading: false, isError: action?.payload };
    },

    /////// Sales Partner Invoice list start //////
    requestSPList: (state) => {
      return {
        ...state,
        isSpLoading: true,
        spInvoiceListData: { list: [], total: 0, limit: 10 },
      };
    },
    responseSPList: (state, action) => {
      return {
        ...state,
        isSpLoading: false,
        spInvoiceListData: action?.payload,
      };
    },
    failureSPList: (state, action) => {
      return { ...state, isSpLoading: false, isError: action?.payload };
    },

    ////////// Sales Partner Invoice Download /////////
    requestSPDownload: (state) => {
      return { ...state, isSpDownloadLoading: true };
    },
    responseSPDownload: (state) => {
      return { ...state, isSpDownloadLoading: false };
    },
    failureSPDownload: (state, action) => {
      return {
        ...state,
        isSpDownloadLoading: false,
        isError: action?.payload,
      };
    },
  },
});

export const {
  requestEInvoiceList,
  responseEInvoiceList,
  failureEInvoiceList,
  requestEInvoiceView,
  responseEInvoiceView,
  failureEInvoiceView,
  requestEInvoiceDownload,
  responseEInvoiceDownload,
  failureEInvoiceDownload,
  requestCorrectRecipients,
  responseCorrectRecipients,
  failureCorrectRecipients,
  requestCreditInvoice,
  responseCreditInvoice,
  failureCreditInvoice,
  requestSPList,
  responseSPList,
  failureSPList,
  requestSPDownload,
  responseSPDownload,
  failureSPDownload,
} = eInvoiceSlice.actions;

export default eInvoiceSlice.reducer;
